<template>
  <div class="lxm-cf-project-feedback">
    <lxm-switch-search :searchPlaceholder="'姓名'"
                       @submit="searchSubmit"
                       @end="searchEnded">
      <span class="lxm-cf-project-feedback__summary-number">{{ state.countSuccess }}</span> 次支付成功&nbsp;
      <!--<span class="lxm-cf-project-feedback__summary-number">{{ state.countFail }}</span> 次支付失败&nbsp;-->
      共计 <span class="lxm-cf-project-feedback__summary-number">{{ amount }}</span>
    </lxm-switch-search>
    <lxm-table :heads="tableHeads"
               :rows="tableRows"
               :tos="tableTos"></lxm-table>
    <lxm-more v-if="state.hasMore" :loading="loading" @click="moreClicked"></lxm-more>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../../styles/index.styl'
  .lxm-cf-project-feedback__summary-number
    color: brand-primary
    font-size: size-big
</style>

<script>
  import LxmSwitchSearch from '../../common/LxmSwitchSearch.vue'
  import LxmTable from '../../common/LxmTable.vue'
  import LxmMore from '../../common/LxmMore.vue'
  import { numberFormat } from '../../../../utils'
  import * as aTypes from '../../../../store/action-types'
  export default {
    components: {
      LxmSwitchSearch,
      LxmTable,
      LxmMore
    },
    data () {
      return {
        searching: false
      }
    },
    computed: {
      loading () {
        return this.$store.state.loading[aTypes.CF_GET_FEEDBACK_LIST]
      },
      state () {
        return this.$store.state.cf.feedback
      },
      amount () {
        return `¥${numberFormat(this.state.amount, true)}`
      },
      tableHeads () {
        return [
          '提交时间',
          '姓名',
          '支持金额',
          '支付状态',
          { type: 'icon', value: '...' }
        ]
      },
      tableRows () {
        return this.state.list.map(s => {
          return [
            s.time,
            s.name,
            `¥${numberFormat(s.amount)}`,
            s.success ? { type: 'text', value: s.statusText, success: true } : { type: 'text', value: s.statusText, fail: true },
            { type: 'icon', value: '>' }
          ]
        })
      },
      tableTos () {
        return this.state.list.map(s => {
          return {
            path: '/main/cf/feedback-detail',
            query: {
              projectId: this.$route.query.projectId,
              donateId: s.id
            }
          }
        })
      }
    },
    watch: {
      $route () {
        this.onMounted()
      }
    },
    mounted () {
      this.onMounted()
    },
    methods: {
      onMounted () {
        this.$store.dispatch(aTypes.GET_NOTIFICATION_STATUS, { type: 'cf_donate', id: this.$route.query.projectId })
        this.$store.dispatch(aTypes.CF_GET, this.$route.query.projectId)
        this.fetchFirstPage()
      },
      moreClicked () {
        if (this.searching === false) {
          this.$store.dispatch(aTypes.CF_GET_FEEDBACK_LIST, {
            id: this.$route.query.projectId,
            page: this.state.currentPage + 1,
            append: true
          })
        } else {
          this.$store.dispatch(aTypes.CF_GET_FEEDBACK_LIST, {
            id: this.$route.query.projectId,
            searchName: this.searching,
            page: this.state.currentPage + 1,
            append: true
          })
        }
      },
      searchSubmit ({ value }) {
        this.searching = value
        this.$store.dispatch(aTypes.CF_GET_FEEDBACK_LIST, {
          id: this.$route.query.projectId,
          searchName: value,
          page: 1,
          append: false
        })
      },
      fetchFirstPage () {
        this.searching = false
        if (this.$store.state.loaded.cf.feedback.id !== this.$route.query.projectId) {
          this.$store.dispatch(aTypes.CF_GET_FEEDBACK_LIST, {
            id: this.$route.query.projectId,
            page: 1,
            append: false
          })
        }
      },
      searchEnded () {
        this.fetchFirstPage()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Feedback.vue?73265127